export default __webpack_public_path__ + "static/icons-bg-green-6494062c8bd963e124139659d6d258e0.svg";